"use client";

import { Input, type InputProps } from "@medimo/ui";
import { Eye, EyeOff } from "lucide-react";
import * as React from "react";

export const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    return (
      <div className="relative">
        <Input type={showPassword ? "text" : "password"} ref={ref} {...props} />
        <div className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3 text-gray-400">
          {showPassword ? (
            <EyeOff className="h-4 w-4" onClick={togglePasswordVisibility} />
          ) : (
            <Eye className="h-4 w-4" onClick={togglePasswordVisibility} />
          )}
        </div>
      </div>
    );
  },
);
